var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as EventService from '../service/event-service.js';
/**
 *
 * This class defines a Bot Response associated to an [[Event]].
 *
 * @public
 */
export class BotResponse {
    constructor(event, payload) {
        this.event = event;
        this.payload = payload || {};
    }
    /**
     * Gets the type of this Bot Response.
     *
     * @returns The type of this Bot Response
     */
    getType() {
        return this.payload.type;
    }
    /**
     * Gets the agent id of this Bot Response.
     *
     * @returns The agent id of this Bot Response
     */
    getAgentId() {
        return this.payload.agentId;
    }
    /**
     * Gets the message of this Bot Response.
     *
     * @returns The message of this Bot Response
     */
    getMessage() {
        return this.payload.message;
    }
    /**
     * Gets the date this Bot Response was created.
     *
     * @returns The date this Bot Response was created
     */
    getCreatedAt() {
        return this.payload.createdAt ? new Date(new Number(this.payload.createdAt).valueOf()) : undefined;
    }
    /**
     * Gets the Event this Bot Response is associated to.
     *
     * @returns The Event this Bot Response is associated to
     */
    getEvent() {
        return this.event;
    }
    /**
     * Replay this Bot Response.
     *
     * @returns The updated Bot Response
     */
    replay() {
        return __awaiter(this, void 0, void 0, function* () {
            const eventId = this.event.getId();
            if (eventId == null) {
                throw new Error("Event id null!");
            }
            const agentId = this.getAgentId();
            if (agentId == null) {
                throw new Error("Agent id null!");
            }
            const updatedEventPayload = yield EventService.replayBotResponse(this.event.getBook(), eventId, agentId, this.event.getBook().getConfig());
            this.updateCache(updatedEventPayload);
            return this;
        });
    }
    /**
     * Delete this Bot Response.
     *
     * @returns The deleted Bot Response
     */
    remove() {
        return __awaiter(this, void 0, void 0, function* () {
            const eventId = this.event.getId();
            if (eventId == null) {
                throw new Error("Event id null!");
            }
            const agentId = this.getAgentId();
            if (agentId == null) {
                throw new Error("Agent id null!");
            }
            const updatedEventPayload = yield EventService.deleteBotResponse(this.event.getBook(), eventId, agentId, this.event.getBook().getConfig());
            this.updateCache(updatedEventPayload);
            return this;
        });
    }
    /** @internal */
    updateCache(updatedEventPayload) {
        var _a;
        // Update event
        this.event.payload = updatedEventPayload;
        this.event.clearCache();
        // Update bot response
        const updatedBotResponsePayload = (_a = updatedEventPayload === null || updatedEventPayload === void 0 ? void 0 : updatedEventPayload.botResponses) === null || _a === void 0 ? void 0 : _a.find(r => r.agentId && r.agentId === this.getAgentId());
        this.payload = updatedBotResponsePayload || {};
    }
}
//# sourceMappingURL=BotResponse.js.map